import React from 'react'
import SpeakUpFormPart from '../../react4xp/components/FormPages/SpeakUpForm'
import { country_list } from '/lib/modules/util/constants'

function SpeakUpForm({ breadcrumbs, title, intro, emailServiceUrl, privacyPolicyCheckboxRichText, recaptchaSiteKey, recaptchaValidationUrl, validationSummary}) {
    return (
        <SpeakUpFormPart
            siteKey={recaptchaSiteKey}
            validationRecaptchaUrl={recaptchaValidationUrl}
            topInfos={{
                title: title,
                intro: intro
            }}
            form={{
                endpoint: emailServiceUrl,
                onSuccess: () => console.log('Sending email...'),
                onError: () => console.error('Error sending email')
            }}
            steps={{
                step1: {
                    title: 'Fill in your details',
                    inputs: [
                        {
                            id: 'relationship',
                            name: 'Relationship with Jotron',
                            label: 'What is your relationship with Jotron?',
                            defaultValue: 'Please select one',
                            options: [
                                { label: 'Customer', value: 'Customer' },
                                { label: 'Supplier', value: 'Supplier' },
                                { label: 'Other', value: 'Other' }
                            ],
                            required: true,
                            errorMessages: {
                                required: 'This field is required.'
                            }
                        },
                        {
                            type: 'text',
                            id: 'other-relationship',
                            name: 'Please specify',
                            label: 'Please specify',
                            required: true,
                            errorMessages: {
                                required: 'This field is required.'
                            }
                        },
                        {
                            id: 'anonymous',
                            name: 'Anonymous',
                            label: 'Would you like to remain anonymous?',
                            defaultValue: 'Please select one',
                            options: [
                                { label: 'Yes', value: 'Yes' },
                                { label: 'No', value: 'No' }
                            ],
                            required: true,
                            errorMessages: {
                                required: 'This field is required.'
                            },
                            helperText: 'Please note that if you choose to remain anonymous, we will not be able to keep you informed and ask any questions that might be important to your case.'
                        },
                        {
                            type: 'text',
                            id: 'first-name',
                            name: 'First name',
                            label: 'First name',
                            required: true,
                            errorMessages: {
                                required: 'This field is required.'
                            }
                        },
                        {
                            type: 'text',
                            id: 'last-name',
                            name: 'Last name',
                            label: 'Last name'
                        },
                        {
                            type: 'email',
                            id: 'email',
                            name: 'Email',
                            label: 'Email',
                            required: true,
                            errorMessages: {
                                required: 'This field is required.',
                                invalidEmail: 'Invalid email format.'
                            }
                        },
                        {
                            type: 'tel',
                            id: 'phone-number',
                            name: 'Phone number',
                            label: 'Phone number',
                            required: true,
                            errorMessages: {
                                required: 'This field is required.'
                            }
                        },
                        {
                            id: 'country',
                            name: 'Country',
                            label: 'What country are you reporting from?',
                            defaultValue: 'Choose country',
                            options: country_list,
                            required: true,
                            errorMessages: {
                                required: 'This field is required.'
                            }
                        }
                    ]
                },
                step2: {
                    title: 'About your concern',
                    inputs: [
                        {
                            type: 'textarea',
                            textarea: {
                                id: 'where',
                                name: 'Where',
                                label: 'Where did the concern arise?',
                                placeholder: 'Write your comment here...',
                                required: true,
                                errorMessages: {
                                    required: 'This field is required.'
                                },
                                helperText: 'Please specify in which country, city and specific location/installation. If the concern arised from observed documentation, please indicate this.'
                            }
                        },
                        {
                            type: 'textarea',
                            textarea: {
                                id: 'when',
                                name: 'First identified',
                                label: 'When was the concern first identified?',
                                placeholder: 'Write your comment here...',
                                required: true,
                                errorMessages: {
                                    required: 'This field is required.'
                                },
                                helperText: 'Please provide a specific or approximate date.'
                            }
                        },
                        {
                            type: 'textarea',
                            textarea: {
                                id: 'describe',
                                name: 'Describe the concern',
                                label: 'Please describe the concern as detailed and accurate as possible.',
                                placeholder: 'Write your comment here...',
                                required: true,
                                errorMessages: {
                                    required: 'This field is required.'
                                },
                                helperText: 'Please distinguish between what you know and what you assume or believe.'
                            }
                        },
                        {
                            type: 'select',
                            select: {
                                id: 'ongoing',
                                name: 'Still ongoing?',
                                label: 'Is the reported concern still ongoing?',
                                defaultValue: 'Please select one',
                                options: [
                                    { label: 'Yes', value: 'Yes' },
                                    { label: 'No', value: 'No' },
                                    { label: "Don't know", value: "Don't know" }
                                ],
                                required: true,
                                errorMessages: {
                                    required: 'This field is required.'
                                }
                            }
                        },
                        {
                            type: 'textarea',
                            textarea: {
                                id: 'individual-concern',
                                name: 'List of individual(s)',
                                label: 'Please list the individual(s) involved in this concern.',
                                placeholder: 'Write your comment here...',
                                required: true,
                                errorMessages: {
                                    required: 'This field is required.'
                                },
                                helperText: 'For each person, please include name, employer and role in the case.'
                            }
                        },
                        {
                            type: 'textarea',
                            textarea: {
                                id: 'aware',
                                name: 'Other individuals',
                                label: 'Are you aware of other individuals who have knowledge of the reported concern?',
                                placeholder: 'Write your comment here...',
                                helperText: 'For each person, please include name and employer.'
                            }
                        },
                        {
                            type: 'upload',
                            upload: {
                                id: 'upload',
                                name: 'upload-file',
                                label: 'Do you have documents that support your concern?',
                                uploadButtonText: 'Choose a file to upload',
                                accept: 'text/csv, application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.oasis.opendocument.spreadsheet, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document, application/vnd.oasis.opendocument.text, application/pdf, text/plain, application/vnd.ms-powerpoint, application/vnd.openxmlformats-officedocument.presentationml.presentation, application/vnd.oasis.opendocument.presentation, image/jpeg, image/png, image/gif, image/webp',
                                multiple: true,
                                maxFileSize: 5,
                                helperText: 'Please note that providing documentation will assist in any subsequent investigation.',
                                errorMessages: {
                                    maxFileSize: 'File size exceeds the 5MB limit. Please upload a smaller file.',
                                    format: 'File format not supported. Please upload an image (.jpg, .png, etc.) or a document (.csv, .xls, .pdf, etc.) file.'
                                }
                            }
                        },
                        {
                            type: 'textarea',
                            textarea: {
                                id: 'other-comments',
                                name: 'Other comments',
                                label: 'Do you have any other comments you would like to share?',
                                placeholder: 'Write your comment here...',
                                helperText: 'You are invited to submit any suggestions you have for investigation that you believe will effectively verify or validate the concern.'
                            }
                        }
                    ]
                }
            }}
            privacyCheckbox={{
                name: 'terms',
                required: true,
                errorMessages: {
                    required: 'This field is required.'
                },
                text: privacyPolicyCheckboxRichText
            }}
            submit={{
				validationMessage: validationSummary,
                label: 'Submit',
                successMessage: 'Your message has been submitted successfully.'
            }}
        />
    )
}

export default SpeakUpForm